import { Spin as AntdSpin } from "antd"
import { defaultProps, SpinnerProps } from "./Spinner.type"
import styles from "./Spinner.module.scss";

export const Spinner = (props: SpinnerProps) => {
	const { ...attributes } = { ...defaultProps, ...props }

	return <AntdSpin {...attributes} className={styles.Spinner} />
};
